<form noValidate ngNoForm [action]="formAction" [method]="currentLoginTypeConfig.method">
  <div class="form-group" [formGroup]="group">
    <mat-form-field appearance="outline" hideRequiredMarker>
      <mat-label>Email</mat-label>
      <input
        matInput
        type="email"
        [name]="controls.Email"
        [formControlName]="controls.Email"
        required
        data-cy="user-email"
        spellcheck="false"
        (keypress)="onUserInput()"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" hideRequiredMarker>
      <mat-label>Password</mat-label>
      <input
        matInput
        type="password"
        [name]="controls.Password"
        [formControlName]="controls.Password"
        required
        data-cy="current-password"
        (keypress)="onUserInput()"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" class="hidden" hideRequiredMarker *ngIf="isZendeskLogin">
      <mat-label>Type</mat-label>
      <input matInput type="text" [name]="controls.Type" [formControlName]="controls.Type" />
    </mat-form-field>
  </div>

  <button
    mat-raised-button
    color="primary"
    type="submit"
    data-cy="sign-in-btn"
    [disabled]="group.invalid"
    [style.filter]="this.colorAnimation.hueRotate$ | async"
  >
    Sign in
  </button>

  <a *ngIf="!isZendeskLogin" class="link-action" routerLink="/forgot-password.html"
    >Forgot password?</a
  >
</form>

<div class="signup-wrapper" *ngIf="environmentSite === 'community'">
  <div class="signup-label">Don't have an account?</div>
  <div class="signup-link">
    <a [href]="s4eLandingPage"> Create your personal sustainability profile </a>
    and join the community
  </div>
</div>
